import { cn } from '../../utils/cn';

const TONE_ICON_CLASS = {
  sage: 'bg-sage-tint text-sage-on-tint',
  warning: 'bg-warning-tint text-warning-fg',
};

const TONE_GLOW_CLASS = {
  sage: 'bg-sage-glow-soft',
  warning: 'bg-warning-glow',
};

/**
 * Empty / zero-state com tom calmo e educativo. Aceita um Icon component (ex: lucide).
 * `.pen`: D3C9Yt (ds/empty-state) — `tone="warning"` é a variante de erro
 * (fundo/ícone amber em vez de sage).
 */
export function EmptyState({ icon: Icon, title, description, action, tone = 'sage', className }) {
  return (
    <div
      data-ds-id="ds/empty-state"
      className={cn(
        'flex flex-col items-center gap-space-4 rounded-ds-lg border border-dashed border-border bg-card p-space-8 text-center',
        className,
      )}
    >
      {Icon ? (
        <div
          className={cn(
            'relative flex h-12 w-12 items-center justify-center rounded-full',
            TONE_ICON_CLASS[tone] || TONE_ICON_CLASS.sage,
          )}
        >
          <span
            className={cn('absolute inset-0 -z-10 rounded-full blur-2xl', TONE_GLOW_CLASS[tone] || TONE_GLOW_CLASS.sage)}
            aria-hidden
          />
          <Icon className="h-6 w-6" aria-hidden />
        </div>
      ) : null}
      {title ? (
        <h3 className="type-title-card font-semibold text-foreground">{title}</h3>
      ) : null}
      {description ? (
        <p className="max-w-[38ch] text-type-body-sm text-muted-foreground">{description}</p>
      ) : null}
      {action ? <div>{action}</div> : null}
    </div>
  );
}
